import { PlatformContext } from "./context";
import { useProviderStore } from "./store";

import type { Context as ContextType } from "react";
import type { StoreProvider } from "./store";
import type {
  PlatformOS,
  PlatformProviderProps,
  PlatformProviderState,
} from "./types";

function PlatformProvider<TPlatform extends PlatformOS>({
  children,
  ...props
}: PlatformProviderProps<TPlatform>) {
  const Context = PlatformContext as ContextType<
    StoreProvider<PlatformProviderState<TPlatform>>
  >;
  const { value } = useProviderStore(props);

  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function WebPlatformProvider(props: PlatformProviderProps<"web">) {
  return <PlatformProvider<"web"> {...props} />;
}

export function NativePlatformProvider(props: PlatformProviderProps<"native">) {
  return <PlatformProvider<"native"> {...props} />;
}
